import React from "react";
import css from "./section.module.css";
import resources from '../../../../resources/index'
const Section6 = () => {
  return (
    <div className={css.section6}>
      <div className={css.section6_div1}>
        <h4>FAQ</h4>
        <h2>Frequently Asked Questions</h2>
        <p>
          Conveniently mesh cooperative services via magnetic outsourcing.
          Dynamically grow value whereas accurate e-commerce vectors.
        </p>
      </div>

      <div className={css.section6_div2}>
        <div className={css.section6_div2_text}>
          <div className={css.text}>
            <h3>
              <span>1.</span> How does back pricing work?
            </h3>
            <p>
              Progressively e-enable collaborative inexpensive supply chains.
              Efficiently maintain economically methods of empowerment for
              synergistic sound scenarios.
            </p>
          </div>
          <div className={css.text}>
            <h3>
              <span>2.</span> How does back pricing work?
            </h3>
            <p>
              Globally benchmark customized mindshare before clicks-and-mortar
              partnerships. Efficiently maintain economically sound scenarios
              and whereas client-based progressively.
            </p>
          </div>
          <div className={css.text}>
            <h3>
              <span>3.</span> Can you show me an example?
            </h3>
            <p>
              Dynamically visualize whereas competitive relationships.
              Progressively benchmark customized partnerships generate
              interdependent benefits rather sound scenarios and robust
              alignments.
            </p>
          </div>
        </div>
        <div className={css.section6_div3_img}>
          <div className={css.img_div}>
            <img src={resources.images.home_sec1}  alt="Home Section 6"/>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Section6;
